import React, { memo, forwardRef } from "react";
const SvgEvaluatefunction = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={10} height={14} x={5} y={9} fill="#DBDBDB" rx={2} />
      <rect width={7} height={9} x={21} y={3} fill="#DBDBDB" rx={1} />
      <rect width={7} height={9} x={21} y={20} fill="#DBDBDB" rx={1} />
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeWidth={2}
        d="M18 5v22"
      />
    </svg>
  );
});
SvgEvaluatefunction.displayName = "SvgEvaluatefunction";
const MemoForwardRef = memo(SvgEvaluatefunction);
export default MemoForwardRef;
